<template>
  <div class="description">{{ description }}</div>
</template>

<script>
export default {
  name: 'Empty',
  props: {
    description: {
      type: String
    }
  }
};
</script>

<style scoped>
.description {
  display: flex;
  justify-content: center;
  align-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Empty.vue